import React, { Component } from "react";
import Header from "../components/Header";

class MadaveCases extends Component {
  render() {
    return (
      <div className="original madave-cases-page">
        <div className="dashboard">
          <div className="main-content">
            <div className="header-con">
              <Header title="MadaveCases" />
            </div>
          </div>
        </div>
        <iframe
          src="https://showcase.kwiat.com"
          title="Madave Cases"
        />
      </div>
    );
  }
}

export default MadaveCases;
